
import { PrivateForm, tools } from '@wenjuan/business'
import { mapMutations } from 'vuex'
import FloatAdcode from '@/components/home/float-adcode.vue'
import { createObserver, getElemPos } from '~/utils/tools.js'
import { httpMemberPackageInfo, getUserInfo, bindingSaler } from '~/api/common.js'
import $WATCH from '~/api/watch-pipe.js'
export default {
  name: 'SeniorDemo',
  components: {
    PrivateForm,
    FloatAdcode,
  },
  layout: 'template-page',
  data() {
    return {
      showPrivateForm: false, // 显示部署版登记弹窗
      showConsultDialog: false, // 显示咨询顾问弹窗
      lowestVersionStr: 'advance_version',
      activeVersionStr: 'advance_version',
      useBack: false,
      memberPKGInfo: {}, // 当前用户套餐信息
      intersections: {
        top: '',
        body: '',
        end: '',
      },
      hasBindMobile: true,
      titleList1: [
        '60万+模板资源',
        '每天可创建项目数',
        '每个项目题目数上限',
        '每个选择题选项数上限',
        '设置题目跳转和显示逻辑',
        '项目添加在线音视频',
        '项目添加本地视频',
        '项目添加本地音频',
        '项目添加附件',
        '自定义答题视频页眉',
        '自定义答题加载动效',
        '360评估功能',
      ],
      dataList1: [
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ text: '20个' }, { text: '50个' }, { text: '80个' }, { text: '100个' }],
        [{ text: '1000题' }, { text: '1200题' }, { text: '1400题' }, { text: '1600题' }],
        [{ text: '200个' }, { text: '300个' }, { text: '400个' }, { text: '500个' }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { text: '最大50MB/个' }, { text: '最大100MB/个' }, { text: '最大200MB/个' }],
        [{ nosatisfies: true }, { text: '最大10MB/个' }, { text: '最大20MB/个' }, { text: '最大50MB/个' }],
        [{ nosatisfies: true }, { nosatisfies: true }, { text: '最大20MB/个' }, { text: '最大50MB/个' }],
        [{ nosatisfies: true }, { nosatisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { nosatisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { nosatisfies: true }, { satisfies: true }, { satisfies: true }],
      ],
      titleList2: [
        '答题页面不展示广告',
        '隐藏答题页问卷网标志',
        '替换答题页问卷网标志',
        '自定义邮件分享发件地址',
        '自定义短信前缀品牌签名',
        '关注品牌的服务号才能答题',
        '关注品牌的服务号才能领红包',
        '自定义答题链接域名',
      ],
      dataList2: [
        [
          { nosatisfies: true },
          { text: '10万次（支持增购）' },
          { text: '30万次（支持增购）' },
          { text: '150万次（支持增购）' },
        ],
        [{ nosatisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { nosatisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { nosatisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { nosatisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { nosatisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { nosatisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { nosatisfies: true }, { text: '支持http' }, { text: '支持http和https' }],
      ],
      titleList3: [
        '项目收集答卷数量无上限',
        '有偿样本服务',
        '限定手机号答题',
        '限定ip地址答题<a class="xingxing mouse-pointer" href="#target-aim" title="IP地址位置数据由纯真CZ88提供支持">*</a>',
        '微信红包',
        '通过短信分享问卷',
        '通过邮件分享问卷',
        '自定义抽奖',
        '投票墙',
        '微信签到',
        '配额',
        '地图导航题',
        '地理位置题精准定位',
        '满意度维度设置',
        '单个文件最大限制',
        '文件上传空间大小',
      ],
      dataList3: [
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }], // 限定IP地址
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ text: '30MB' }, { text: '50MB' }, { text: '100MB' }, { text: '200MB' }],
        [
          { text: '1GB/月（不可增购）' },
          { text: '10GB/月（可增购）' },
          { text: '20GB/月（可增购）' },
          { text: '50GB/月（可增购）' },
        ],
      ],
      titleList4: [
        '项目协作',
        '项目数据公开分享',
        '分享项目数据支持下载',
        '文件夹协作',
        '企业子账号（￥500/人/年）',
        '企业子账号权限管理',
      ],
      dataList4: [
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { nosatisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { nosatisfies: true }, { text: '10个（支持增购）' }, { text: '30个（支持增购）' }],
        [{ nosatisfies: true }, { nosatisfies: true }, { satisfies: true }, { satisfies: true }],
      ],
      titleList5: [
        '自定义答题来源',
        '自定义答卷参数',
        '打开答题页时跳转指定页面',
        '提交答卷后跳转指定页面',
        '开放平台API对接',
        '开放平台消息推送',
      ],
      dataList5: new Array(6).fill([
        { nosatisfies: true },
        { nosatisfies: true },
        { satisfies: true },
        { satisfies: true },
      ]),
      titleList6: ['练习模式', '考试防作弊', '考试交卷时间设置', '考试排行榜', '按得分设置结束语', '考试证书'],
      dataList6: [
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ satisfies: true }, { satisfies: true }, { satisfies: true }, { satisfies: true }],
        [{ nosatisfies: true }, { nosatisfies: true }, { satisfies: true }, { satisfies: true }],
      ],
      stripe: ['odd', 'even'],
      qaList: [
        [
          'Q1. 问卷网可以使用哪些场景和题型？',
          '问卷网现提供问卷调查、满意度调查、投票评选、报名登记表、考试测评等场景。题型涵盖单选/多选题、图片选择/上传题、投票题、填空题、打分题、人口统计信息题等40多种题型。',
        ],
        [
          'Q2. 如何确保数据存储安全性？',
          '问卷网始终将数据安全放在第一位。我们对系统部署了完善的加密功能，使用Https加密协议，保证数据在传输过程中绝对安全，同时在服务器端配置有完善的数据备份方案，让您安心使用无后顾之忧。',
        ],
        [
          'Q3. 如何支付并购买套餐？',
          '问卷网PC端提供了微信支付和支付宝支付两种在线支付方式。同时我们还提供了线下支付，在问卷网PC端进入“我的账户-我的钱包”，选择“银行转账”后根据转账提示完成转账。我们将在工作日的24h内为您的账户充值，您可使用账户余额购买套餐。',
        ],
      ],
      showTxt: true,
      sale: false,
    }
  },
  fetchOnServer: false,
  async fetch() {
    try {
      const { data } = await getUserInfo()
      this.$store.commit('setLoginStatus', { loggedIn: 1 })
      this.hasBindMobile = !!data?.mobile
      if (this.loggedIn && !data.custom_attr.channel_code && this.$route.query.channel_code) {
        console.log('已登陆且未绑定销售且是销售链接')
        await bindingSaler({ channel_code: this.$route.query.channel_code })
      }
      const res = await httpMemberPackageInfo({ is_get_personal_package_info: 1 })
      if (res.status_code === 1) {
        this.memberPKGInfo = res.data
        // 存储购买弹窗接口的存储数据
        this.$store.commit('member/setPackageInfo', res.data)
      }
    } catch (e) {
      console.log(e, 'featch请求错误')
    }
  },
  head: {
    title: '问卷网_免费版、高级版、定制版的区别',
    link: [{ rel: 'canonical', href: 'https://www.wenjuan.com/senior_user/' }],
    meta: [
      {
        hid: 'keywords',
        name: 'keywords',
        content: '免费版，高级版，定制版，调查问卷，问卷调查，问卷网',
      },
      {
        hid: 'description',
        name: 'description',
        content: '问卷网，免费专业的在线调研、报名表单、考试测评平台。用户可查看问卷网免费版、高级版、定制版的区别。',
      },
    ],
    script: [{ src: '//s1.wenjuan.com/lib/jquery/1.8.3/jquery.min.js' }],
  },
  computed: {
    microAppInfo() {
      return tools.$ENV.defineState()
    },
    loggedIn() {
      return this.$store.state.loginStatus.loggedIn == 1
    },
    version() {
      return this.memberPKGInfo.package_status ? this.memberPKGInfo.package_status.version : 'free'
    },
  },
  mounted() {
    $WATCH.on('headerEndFetchUserInfo', () => {
      // this.isShowPrivateForm()
      if (this.loggedIn && sessionStorage && sessionStorage.getItem('version')) {
        this.handleBuy(sessionStorage.getItem('version'))
        sessionStorage.removeItem('version')
      }
      if (this.loggedIn && sessionStorage && sessionStorage.getItem('tryApply')) {
        this.tryApply()
      }
    })
    const preLoad = window.onload
    window.onload = () => {
      preLoad && preLoad()
      this.$nextTick(() => {
        this.setHightLightHeader({
          active: 'senior_user',
        })
        const VM = this.$refs['watch-line']
        const watchEnd = this.$refs['watch-end']
        VM &&
          watchEnd &&
          createObserver({
            threshold: [0, 0.1, 0.2, 0.9, 1],
          })
            .add(VM)
            .then((status) => {
              this.useBack = !status
              this.showTxt = status
            })
            .add(watchEnd)
            .then((status, { boundingClientRect: { bottom } }) => {
              if (!status && this.useBack && !this.showTxt && bottom < 300) this.useBack = false
              if (status && !this.useBack) this.useBack = true
            })
      })
    }
    if (this.$route.query.channel_code) {
      this.sale = true
      document.getElementsByClassName('header-wrap')[0].style.display = 'none'
      document.getElementById('common-footer').style.display = 'none'
      this.$refs.wrapper.style.display = 'none'
      document.getElementsByClassName('dome-body_foot')[0].style.display = 'none'
    }
  },
  methods: {
    ...mapMutations(['setHightLightHeader']),
    handleBuy(ver) {
      if (!this.loggedIn) {
        this.$store.commit('setLoginStatus', {
          show: true,
          nextUrl: () => {
            sessionStorage && sessionStorage.setItem('version', ver)
            window.location.reload()
          },
        })
        return
      }
      const versionList = ['free', 'advance_version', 'enterprise_version', 'enterprise_ultimate_version']
      // 显示最低版本为当前版本的下一级，若为旗舰版则只显示旗舰版
      const index = versionList.indexOf(this.version) === 3 ? 3 : versionList.indexOf(this.version) + 1
      this.lowestVersionStr = this.microAppInfo.isFreeTry ? 'advance_version' : versionList[index]
      // 高亮版本为点击版本
      this.activeVersionStr = ver
      // 显示新版购买弹窗
      this.openPackageDialog()
    },
    addRegister() {
      if (!this.loggedIn) {
        this.$store.commit('setLoginStatus', {
          show: true,
          nextUrl: () => {
            sessionStorage && sessionStorage.setItem('openPrivateForm', '1')
            window.location.reload()
          },
        })
      } else {
        this.showPrivateForm = false
        this.showConsultDialog = true
        sessionStorage.removeItem('openPrivateForm')
      }
    },
    enter() {
      if (!this.loggedIn) {
        this.$store.commit('setLoginStatus', {
          show: true,
          nextUrl: async () => {
            if (this.$route.query.channel_code) {
              await bindingSaler({ channel_code: this.$route.query.channel_code })
            }
            this.$href('/list')
          },
        })
      } else {
        this.$href('/list')
      }
    },
    tryApply() {
      if (!this.loggedIn) {
        this.$store.commit('setLoginStatus', {
          show: true,
          nextUrl: () => {
            sessionStorage && sessionStorage.setItem('tryApply', '1')
            window.location.reload()
          },
        })
      } else {
        // window.location.href = '/list/'
        this.$href('https://www.wenjuan.com/s/UZBZJvX9GO6/#')
        sessionStorage.removeItem('tryApply')
      }
    },
    // 购买支付结束
    payCompleted(result) {
      if (result) {
        // 刷新页面
        window.location.reload()
      }
    },
    // isShowPrivateForm() {
    //   if (this.loggedIn && sessionStorage && sessionStorage.getItem('openPrivateForm')) {
    //     this.showPrivateForm = true
    //     sessionStorage.removeItem('openPrivateForm')
    //     return
    //   }

    //   const hash = window.location.hash
    //   if (hash === '#private') {
    //     this.gotoWrapper()
    //     this.addRegister()
    //   }
    // },
    // 滚动到广告投放标签 ref=wrapper
    gotoWrapper() {
      const yPos = getElemPos(this.$refs.wrapper).y
      document.body.scrollTop = document.documentElement.scrollTop = yPos - 100
    },
    // 打开购买弹窗
    openPackageDialog() {
      // 混乱的弹窗模式， 10月需要修复
      this.$store.commit('setPackageDialog', {
        show: true,
        lowestVersion: this.lowestVersionStr,
        activeVersion: this.activeVersionStr,
        source: '套餐页面',
        on: {
          payment: this.payCompleted,
        },
      })
    },
  },
}
